import {
  FurnitureCategory,
  RoomType,
  type FurnitureCategory as FurnitureCategoryType,
  type RoomType as RoomTypeType,
} from "../types/C1_ModelTypes";

export const C1_ROOM_TYPE_TO_FURNITURE_CATEGORY = {
  [RoomType.Living]: FurnitureCategory.Living,
  [RoomType.Dining]: FurnitureCategory.Dining,
  [RoomType.Kitchen]: FurnitureCategory.Kitchen,
  [RoomType.Hallway]: FurnitureCategory.All,
  [RoomType.Staircase]: FurnitureCategory.Staircase,
  [RoomType.GuestToilet]: FurnitureCategory.Bathroom,
  [RoomType.Utility]: FurnitureCategory.Utility,
  [RoomType.Office]: FurnitureCategory.Office,
  [RoomType.Child]: FurnitureCategory.Office,
  [RoomType.Bathroom]: FurnitureCategory.Bathroom,
  [RoomType.Bedroom]: FurnitureCategory.Bedroom,
  [RoomType.Storage]: FurnitureCategory.Storage,
  [RoomType.Hobby]: FurnitureCategory.All,
  [RoomType.Laundry]: FurnitureCategory.All,
  [RoomType.HeatingRoom]: FurnitureCategory.HeatingRoom,
  [RoomType.UtilityConnectionRoom]: FurnitureCategory.UtilityConnectionRoom,
  [RoomType.Garage]: FurnitureCategory.All,
  [RoomType.DetachedGarage]: FurnitureCategory.All,
  [RoomType.Carport]: FurnitureCategory.Outdoor,
  [RoomType.Other]: FurnitureCategory.All,
  [RoomType.Terrace]: FurnitureCategory.Outdoor,
  [RoomType.Balcony]: FurnitureCategory.All,
  [RoomType.Garden]: FurnitureCategory.Outdoor,
  [RoomType.Entrance]: FurnitureCategory.Outdoor,
  [RoomType.GarageDriveway]: FurnitureCategory.Outdoor,
  [RoomType.RoofTerrace]: FurnitureCategory.All,
  [RoomType.PenthousePerimeter]: FurnitureCategory.Outdoor,
  [RoomType.Roof]: FurnitureCategory.All,
} satisfies Record<RoomTypeType, FurnitureCategoryType>;

export function furnitureCategoryForRoomType(roomType: RoomTypeType): FurnitureCategoryType {
  return C1_ROOM_TYPE_TO_FURNITURE_CATEGORY[roomType];
}
